var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGewerbekunde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 100,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00488E",
    className: "cls-1",
    d: "m185.37,81.08c-8.4-1.47-31.97-1.67-45.94-.61V22.89s-3.98-.83-3.98-.83c-13.49-2.81-55.16-2.83-71.92-.04l-4.18.7v27.87c-12.8-1.3-35.49-1.02-45.58.88l-4.08.77v127.35h179.82v-97.78s-4.14-.72-4.14-.72Zm-126.02,88.51h-14.8v-19.74h-10.05v19.74h-14.8V60.7c11.21-1.28,30.12-1.17,39.66-.07v108.96Zm30.04,0v-39.47h20v39.47h-20Zm40.04,0h-10.04v-49.47h-40v49.47h-10.04V31.31c16.39-1.87,46.54-1.69,60.08-.08v138.36Zm50.08,0h-15.01v-19.79h-10.05v19.79h-15.01v-79.09c11.36-.95,30.33-.87,40.08-.05v79.14Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    className: "cls-1",
    x: 34.46,
    y: 69.59,
    width: 10.05,
    height: 20.24
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    className: "cls-1",
    x: 34.46,
    y: 99.77,
    width: 10.05,
    height: 20.12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    className: "cls-1",
    x: 154.44,
    y: 99.97,
    width: 10.05,
    height: 20.24
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    className: "cls-1",
    x: 154.44,
    y: 130.14,
    width: 10.05,
    height: 10.06
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    className: "cls-1",
    x: 84.36,
    y: 79.78,
    width: 10.05,
    height: 10.05
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    className: "cls-1",
    x: 104.54,
    y: 79.78,
    width: 10.05,
    height: 10.05
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    className: "cls-1",
    x: 104.54,
    y: 99.77,
    width: 10.05,
    height: 10.05
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    className: "cls-1",
    x: 84.36,
    y: 99.77,
    width: 10.05,
    height: 10.05
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    className: "cls-1",
    x: 84.36,
    y: 39.75,
    width: 10.05,
    height: 10.05
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    className: "cls-1",
    x: 104.54,
    y: 39.75,
    width: 10.05,
    height: 10.05
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    className: "cls-1",
    x: 104.54,
    y: 59.74,
    width: 10.05,
    height: 10.05
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    className: "cls-1",
    x: 84.36,
    y: 59.74,
    width: 10.05,
    height: 10.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGewerbekunde);
export default __webpack_public_path__ + "static/media/gewerbekunde.e2dc1aa6f4169ba5467d1bf7d2467a59.svg";
export { ForwardRef as ReactComponent };